import Flickity from 'flickity';

export default class HiringProcess {
  constructor() {
    const $els = document.querySelectorAll('.js-hiring-process');
    $els.forEach($el => new Carousel($el));
  }
}

class Carousel {
  constructor($el) {
    this.$el = $el;
    this.$carousel = this.$el.querySelector('.js-hiring-process-carousel');
    this.$nextBtn = this.$el.querySelector('.js-hiring-process-carousel-next-btn');
    this.$prevBtn = this.$el.querySelector('.js-hiring-process-carousel-prev-btn');

    this.flickity = new Flickity(this.$carousel, {
      imagesLoaded: true,
      prevNextButtons: false,
      pageDots: true,
      cellAlign: 'center',
      draggable: window.innerWidth < 768, // can't drag and animate the variable centre width
      groupCells: 1,
      wrapAround: false,
    });

    this.flickity.on('change', this.assignHeights.bind(this))

    this.$nextBtn.addEventListener('click', this.next.bind(this));
    this.$prevBtn.addEventListener('click', this.prev.bind(this));
  }

  assignHeights(index) {
    // only for desktop exp.
    if (window.innerWidth < 768) return;

    // sets a height based off it's distance from the center
    var adjust = (i, pos) => {
      const diff = Math.abs(index - i);

      this.$carousel.querySelector(`.c-hiring-process-card:nth-child(${i + 1})`).style.height = `calc(100% - 2.46rem * ${diff})`;
      this.$carousel.querySelector(`.c-hiring-process-card:nth-child(${i + 1})`).dataset.pos = pos;
      this.$carousel.querySelector(`.c-hiring-process-card:nth-child(${i + 1}) .c-hiring-process-card--title`).style.width = `calc(20rem - 1.6rem * ${diff})`;
    }

    // set heights left of center.
    for (var i = index - 1; i >= 0; i--) {
      adjust(i, 'left')
    }

    // set heights right of center.
    for (var i = index + 1; i < this.flickity.cells.length; i++) {
      adjust(i, 'right')
    }

    // set height in center
    adjust(index, 'center')
  }

  /**
   * @function next
   * @param {Event} e
   * @returns void
   * Goes to next slide in carousel
   */
  next(e) {
    if (!this.flickity) return;

    e.preventDefault();
    this.flickity.next();
    this.flickity.reposition();
  }

  /**
   * @function prev
   * @param {Event} e
   * @returns void
   * Goes to previous slide in carousel
   */
  prev(e) {
    if (!this.flickity) return;

    e.preventDefault();
    this.flickity.previous();
    this.flickity.reposition();
  }
}
